var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUploadImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "cloud_download") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M512,256c0,141.38-114.62,256-256,256S0,397.39,0,256,114.61,0,256,0,512,114.62,512,256Z",
    fill: "#404041"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28,139.52,139.52,28A257.1,257.1,0,0,0,28,139.52Z",
    fill: "#4d4d4f"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M179.06,11.77,11.77,179.06a254.14,254.14,0,0,0-6.43,24.69L203.75,5.34A253.94,253.94,0,0,0,179.06,11.77Z",
    fill: "#4d4d4f"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M231.24,1.2l-230,230Q.27,240.84.07,250.64L250.63.07Q240.84.27,231.24,1.2Z",
    fill: "#4d4d4f"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M273.44.6.6,273.43q.56,8.39,1.66,16.63L290.05,2.26Q281.83,1.17,273.44.6Z",
    fill: "#4d4d4f"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M309.94,5.71,5.71,309.95q1.59,7.41,3.6,14.66L324.6,9.31Q317.35,7.3,309.94,5.71Z",
    fill: "#4d4d4f"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M342.32,14.93,14.94,342.33Q17.32,349,20,355.47L355.46,20Q349,17.31,342.32,14.93Z",
    fill: "#4d4d4f"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M371.41,27.44l-344,344q3,6,6.39,11.86L383.28,33.83Q377.44,30.48,371.41,27.44Z",
    fill: "#4d4d4f"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M397.69,42.77,42.77,397.69q3.63,5.46,7.53,10.72L408.42,50.31Q403.16,46.4,397.69,42.77Z",
    fill: "#4d4d4f"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M421.43,60.64,60.65,421.43q4.18,4.93,8.6,9.65L431.08,69.25Q426.36,64.82,421.43,60.64Z",
    fill: "#4d4d4f"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M442.75,80.91,80.92,442.75q4.72,4.42,9.65,8.6L451.37,90.58Q447.18,85.64,442.75,80.91Z",
    fill: "#4d4d4f"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M461.69,103.58,103.58,461.69q5.26,3.91,10.73,7.54L469.23,114.31Q465.59,108.85,461.69,103.58Z",
    fill: "#4d4d4f"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M478.17,128.72,128.71,478.16q5.84,3.35,11.88,6.4l344-344Q481.51,134.56,478.17,128.72Z",
    fill: "#4d4d4f"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M492,156.53,156.53,492q6.48,2.73,13.14,5.11L497.06,169.67Q494.68,163,492,156.53Z",
    fill: "#4d4d4f"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M502.69,187.41,187.4,502.69q7.24,2,14.66,3.6L506.29,202.06Q504.7,194.65,502.69,187.41Z",
    fill: "#4d4d4f"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M509.74,222,221.94,509.74q8.23,1.09,16.62,1.66L511.4,238.56Q510.83,230.18,509.74,222Z",
    fill: "#4d4d4f"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M510.81,280.75q.92-9.59,1.13-19.38L261.37,511.93q9.79-.2,19.39-1.13Z",
    fill: "#4d4d4f"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M332.92,500.23,500.23,332.92a254,254,0,0,0,6.42-24.68L308.23,506.66A254.22,254.22,0,0,0,332.92,500.23Z",
    fill: "#4d4d4f"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M484,372.49,372.48,484A257.12,257.12,0,0,0,484,372.49Z",
    fill: "#4d4d4f"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M344,222.84c0-.64.09-1.26.09-1.91,0-37.6-30.27-68.06-67.62-68.06-.77,0-1.49.15-2.24.17a12.23,12.23,0,0,1,.67,3.74v84.32h28.62L256,302.45l-47.55-61.36h28.61V165.77a68.09,68.09,0,0,0-23.24,29.7A37,37,0,0,0,194.48,190a37.73,37.73,0,0,0-33.11,55.27A45.45,45.45,0,0,0,168,335.66H335.23A35,35,0,0,0,346,334,57.06,57.06,0,0,0,344,222.84Z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadImage);
export default __webpack_public_path__ + "static/media/upload_image.a66238d48b9587e9368d4264792d4bd2.svg";
export { ForwardRef as ReactComponent };